import a, { useRef as k } from "react";
import { Link as r } from "../../../Link/Link.js";
import "@olxbr/ds-icons";
import { sendClickEvent as n } from "../../utils/sendClickEvent.js";
const d = _ref => {
  let {
    headerWrapperRef: l,
    mainId: s,
    footerId: p,
    notFooter: m
  } = _ref;
  const c = k(null);
  return a.createElement("div", {
    ref: c
  }, a.createElement(r, {
    dsParentName: "Header",
    href: "#header",
    onKeyDown: t => {
      var o;
      if (t.key === "Enter") {
        t.preventDefault();
        const e = (o = l.current) == null ? void 0 : o.querySelector("[data-header-burger-menu]");
        if (window.innerWidth < 840) return e == null ? void 0 : e.focus();
        const i = e == null ? void 0 : e.nextElementSibling;
        i == null || i.focus();
      }
    },
    "data-header-keyboard-navigation": "true",
    className: "olx-header__skip-links",
    onClick: () => n("skip_main_menu")
  }, "Ir para o menu principal"), a.createElement(r, {
    dsParentName: "Header",
    href: s,
    className: "olx-header__skip-links",
    "data-header-keyboard-navigation": "true",
    onClick: () => n("skip_page_content")
  }, "Ir para o conte\xFAdo da p\xE1gina"), !m && a.createElement(r, {
    dsParentName: "Header",
    href: p,
    className: "olx-header__skip-links",
    "data-header-keyboard-navigation": "true",
    onClick: () => n("skip_footer")
  }, "Ir para o rodap\xE9"));
};
d.displayName = "SkipLinks";
export { d as SkipLinks };